import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

export enum FeatureFlagsEnum {
    TRANSPORT_TELERIK_INVOICE_DOWNLOAD = 1,
	TRANSPORT_TELERIK_INVOICE_EMAIL = 2,
	TRANSPORT_TELERIK_INVOICE_SMS = 3,
	TRANSPORT_TELERIK_STATEMENT_UI = 4,
};

export type FeatureFlag = {
    id: number;
    name: string;
    description: string;
    isActive: boolean;
};

@Injectable()
export class FeatureFlagsService {
	constructor(private httpClient: HttpClient) { }

	public async isActive(featureFlag: FeatureFlagsEnum): Promise<boolean> {
		// Check for local override first
		const override = localStorage.getItem(`persist-featureFlag_${featureFlag}_isActive`);
		if (override !== null) {
			return override === 'true';
		}
		const url = `${environment.dotNetApiUrl}/FeatureFlags/${featureFlag}/isEnabled`;
		return await this.httpClient.get<boolean>(url).toPromise();
	}

	public async getAll(): Promise<Array<FeatureFlag>> {
		const url = `${environment.dotNetApiUrl}/FeatureFlags`;
		return await this.httpClient.get<Array<FeatureFlag>>(url).toPromise();
	}
}



// WEBPACK FOOTER //
// ./src/app/shared-services/featureFlags.service.ts